import { FormlyFieldConfigMap } from './formly-field-config.map';
import {LocationSetType} from '@emm/core/models/location-set-type.model';

const locationSetTypesPlaceHolder = 'Search for a Location Set Type';

export const locationSetTypesFilterFieldMap: FormlyFieldConfigMap<LocationSetType> = {
    name: () => ({
        key: 'name',
        templateOptions: {
            label: 'Name',
            maxLength: 512,
            placeholder: locationSetTypesPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    }),
    weight: () => ({
        key: 'weight',
        templateOptions: {
            label: 'Weight',
            maxLength: 512,
            placeholder: locationSetTypesPlaceHolder,
            type: 'number'
        },
        type: 'input',
        wrappers: ['form-field-filter']
    })
};
